import styled from 'styled-components';


export const ModalError = styled.div`
	background-color: #ffd8d8;
	border: 1px solid #ff5e5e;
	padding: 6px 16px;
	font-weight: 500;
	border-radius: 6px;
	color: #ff3a3a;
`

export const TextError = styled.p`
  color: white;
`